<div class="auth-pay-layout-wrap"
    style="background-image: url(./assets/images/photo-wide-4.jpg)">
    <div class="auth-pay-content">
        <router-outlet></router-outlet>
    </div>
</div>